import React from 'react';
import { Box } from 'rebass';
import Details from '../../Details';
import Link from '../../app/components/link';
import Slider from '../../app/components/slider';
import Lead from '../../Lead';
import image1 from '../../app/data/screenshots/buddybet/home.jpg';
import image2 from '../../app/data/screenshots/buddybet/login.jpg';
import image3 from '../../app/data/screenshots/buddybet/playground.jpg';

const images = [
  {
    src: image1,
    alt: 'Buddybet home page',
  },
  {
    src: image2,
    alt: 'Buddybet login panel',
  },
  {
    src: image3,
    alt: 'Buddybet bet with friends',
  },
];

const tags = [
  'Mobile Application',
  'Ember.js',
  'Ember Data',
  'CSS',
  'Agile Development',
];

export default () => (
  <div>
    <Details
      title="Buddybet"
      subtitle="Online Betting"
    >
      <Details.Paragraph emoji="🎲" title="A social betting platform">
        <Link target="_blank" href="https://www.betasmartz.com/">Buddybet</Link> is a social network
        and betting platform that allows users to challenge friends from anywhere in the world to
        bet on sports, events, or any other competition. It is an innovative idea that combines
        social networking aspects and online gambling, and is on course to disrupt the
        traditional model of online betting.
      </Details.Paragraph>
      <Details.Paragraph emoji="❤️" title="Powerful web application">
        Dynopia collaborated with Buddybet on the development of the mobile
        application. We brought the technical knowledge in building mobile applications, and the
        expertise in managing large-scale applications. We&apos;ve worked in close collaboration
        with a large team of designers and developers to deliver a product that is a joy to use.
      </Details.Paragraph>
      <Details.Paragraph emoji="💰" title="$3M seed funding">
        Buddybet is based in Prague and has received considerable attention from investors.
        They have raised $3M from private investors to fund their expansion into mobile apps
        development. The Buddybet platform is integrated on more than 200 websites, including{' '}
        <Link target="_blank" href="http://www.footymad.net/">Footymad</Link>, one of the most
        popular football news website.
      </Details.Paragraph>
      <Details.Tags tags={tags} />
      <Slider images={images} />
      <Box mt={5}>
        <Lead />
      </Box>
    </Details>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/work/buddybet.js